<template>
  <MainTabEvents :main-title="mainTitle" :secondary-title="secondaryTitle">
    <div v-if="ticketFilter === 'festival'" class="main-tab__festival-logo">
      <img :src="logoFestival" alt="logo festival" />
    </div>
    <div v-if="ticketFilter === 'past'" class="main-tab__filters main-tab__filters--events">
      <div class="dea-input-container dea-input-container--events">
        <label class="dea-input-container__label dea-input-container__label--date" for="startDate">
          Seleziona una data
        </label>
        <div class="dea-input-container__inputs">
          <input
            id="startDate"
            v-model="selectedFromDateFilter"
            class="dea-input dea-input--date"
            placeholder="Seleziona Data Inizio"
            type="date"
            lang="it"
            :max="selectedToDateFilter"
            @change="handleSelectedFromDateFilter"
          />
          <input
            id="endDate"
            v-model="selectedToDateFilter"
            class="dea-input dea-input--date"
            placeholder="Seleziona Data Fine"
            type="date"
            lang="it"
            :min="selectedFromDateFilter"
            @change="handleSelectedToDateFilter"
          />
        </div>
      </div>
      <div class="dea-input dea-input--input-select">
        <div class="dea-input__labels">
          <label class="dea-input__label-wrapper" for="input-event-type">
            Stato
          </label>
        </div>
        <div class="dea-input__wrapper">
          <select id="input-event-type" v-model="selectedFilter">
            <option v-for="filter in inputSelectFilters" :key="filter.id" :value="filter.value">
              {{ filter.name }}
            </option>
          </select>
          <div class="dea-input__icon dea-ico-freccia-down"></div>
        </div>
      </div>
    </div>
    <ContentWrapper
      v-if="ticketFilter !== 'notAttended' && ticketFilter !== 'waitingList'"
      :class="contentWrapperExtraClasses"
    >
      <template v-if="registrationsLoaded" #default>
        <component
          :is="getTicketWrapperComponent(registration)"
          v-for="registration in filteredRegistrations()"
          :key="`${registration.id}-${versionIndex}`"
          type="li"
          :registration="registration"
          :package-children="findPackageChildren(registration.id)"
          :waiting-for-payment="registration.to_be_completed"
          :ticket-filter="ticketFilter"
          @changeState="changeView($event)"
          @editLaboratories="editLaboratories"
          @completeSurvey="completeSurvey"
          @downloadFiles="downloadFiles"
        >
          <TicketCard
            :registration="registration"
            :package-children="findPackageChildren(registration.id)"
            @registrationDetail="focusRegistration(registration)"
            @editLaboratories="editLaboratories(registration)"
            @completeSurvey="completeSurvey(registration)"
            @downloadFiles="downloadFiles(registration)"
            @cancelRegistration="triggerRegistrationCancel(registration)"
          ></TicketCard>
          <div v-if="registration.state === 'on_hold'" class="order-confirmation-payment dea-border-grey-medium">
            <OrderConfirmationBodyPayment
              :order="registration.order_data"
              :show-payment-choice="false"
            ></OrderConfirmationBodyPayment>
          </div>
        </component>
        <div v-if="filteredRegistrations().length === 0">
          <h2 class="dea-heading--medium__ml">{{ noEventsTitle }}</h2>
        </div>
        <Modal
          class="dea-modal--survey-reminder dea-modal--no-footer"
          :visible="showModal"
          :is-error="false"
          @modalClose="showModal = false"
        >
          <template #title>Completa il questionario</template>
          <template #content>
            <div class="dea-heading--medium__ms">Per visualizzare i materiali completa prima il questionario.</div>
          </template>
        </Modal>
      </template>
    </ContentWrapper>
    <template v-if="ticketFilter === 'waitingList'">
      <h2 class="dea-heading--medium__l dea-text--left">
        In lista di attesa
      </h2>
      <p v-if="!waitingListRegistrations.length" class="dea-heading--regular-xl">
        Non è presente nessun evento in lista di attesa
      </p>
      <ContentWrapper v-if="waitingListRegistrations.length > 0">
        <TicketCard
          v-for="registration in waitingListRegistrations"
          :key="`${registration.id}-${versionIndex}`"
          :registration="registration"
          type="li"
          @registrationDetail="focusRegistration(registration)"
          @editLaboratories="editLaboratories(registration)"
          @completeSurvey="completeSurvey(registration)"
          @downloadFiles="downloadFiles(registration)"
          @cancelRegistration="triggerRegistrationCancel(registration)"
        ></TicketCard>
      </ContentWrapper>
      <PreRegistrationsHeader
        :types="eventTypes(preRegistrationsFilters)"
        :title="secondaryTitle"
        @change="setPreRegistrationsFilter"
      ></PreRegistrationsHeader>
      <ContentWrapper>
        <TicketCard
          v-for="registration in preRegistrations"
          :key="`${registration.id}-${versionIndex}`"
          :registration="registration"
          type="li"
          @registrationDetail="focusRegistration(registration)"
          @editLaboratories="editLaboratories(registration)"
          @completeSurvey="completeSurvey(registration)"
          @downloadFiles="downloadFiles(registration)"
          @cancelRegistration="triggerRegistrationCancel(registration)"
        ></TicketCard>
      </ContentWrapper>
    </template>
    <ContentWrapper v-if="ticketFilter === 'notAttended'">
      <TicketCard
        v-for="registration in filteredRegistrations()"
        :key="`${registration.id}-${versionIndex}`"
        :registration="registration"
        type="li"
      ></TicketCard>
      <div v-if="filteredRegistrations().length === 0">
        <h2 class="dea-heading--medium__ml">{{ noEventsTitle }}</h2>
      </div>
    </ContentWrapper>
    <PurchaseInfo v-if="filteredRegistrations().length > 0"></PurchaseInfo>
    <PaginationBlock
      v-if="myHomePagination.pages.length > 1"
      :pagination="myHomePagination"
      @changePage="changePage"
    ></PaginationBlock>
  </MainTabEvents>
</template>

<script>
import Links from "@/components/elements/Links";
import PaginationBlock from "@/components/elements/PaginationBlock";
import Modal from "@/components/patterns/Modal";
import ModalAlert from "@/components/patterns/ModalAlert";
import { createFocusTrap } from "focus-trap";
import { mapActions, mapGetters, mapMutations } from "vuex";
import logoFestival from "~/assets/logo_festival.jpg";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import MainTabEvents from "~/components/events/components/MainTabEvents";
import OrderConfirmationBodyPayment from "~/components/events/components/OrderConfirmationBodyPayment";
import PlaceholderComponent from "~/components/events/components/PlaceholderComponent";
import PreRegistrationsHeader from "~/components/events/components/PreRegistrationsHeader";
import PurchaseInfo from "~/components/events/components/PurchaseInfo";
import RegistrationCancellationModal from "~/components/events/components/RegistrationCancellationModal";
import TicketCard from "~/components/events/components/TicketCard";
import TicketPackage from "~/components/events/components/TicketPackage";
import TicketToPayWrapper from "~/components/events/components/TicketToPayWrapper";

export default {
  name: "EventsTickets",
  components: {
    Links,
    MainTabEvents,
    ContentWrapper,
    TicketToPayWrapper,
    TicketPackage,
    TicketCard,
    PlaceholderComponent,
    PreRegistrationsHeader,
    Modal,
    OrderConfirmationBodyPayment,
    PaginationBlock,
    PurchaseInfo,
  },
  data() {
    return {
      ticketWrapperComponent: "",
      versionIndex: 0,
      preRegistrationFilter: "default",
      showModal: false,
      focusTrap: null,
      logoFestival,
      inputSelectFilters: [
        { id: "default", name: "Tutti", value: "" },
        { id: "active", name: "Attivo", value: "active" },
        { id: "past", name: "Partecipato", value: "past" },
        { id: "notAttended", name: "Non partecipato", value: "notAttended" },
      ],
      selectedFilter: "past",
      selectedFromDateFilter: undefined,
      selectedToDateFilter: undefined,
    };
  },
  computed: {
    ...mapGetters([
      "filteredRegistrations",
      "ticketFilter",
      "titles",
      "myHomeRegistrations",
      "activeRegistration",
      "registrations",
      "activeRegistrationIndex",
      "eventTypes",
      "registrationsLoaded",
      "myHomePagination",
      "futureViewFilter",
      "dateParams",
      "waitingListRegistrations",
    ]),
    noEventsTitle() {
      return this.titles.empty[this.ticketFilter];
    },
    mainTitle() {
      return this.titles.main[this.ticketFilter];
    },
    secondaryTitle() {
      return this.titles.secondary[this.ticketFilter];
    },
    contentWrapperExtraClasses() {
      if (this.filteredRegistrations().length === 0) {
        return "content-wrapper--reduced-margin";
      }
      return "";
    },
    preRegistrationsFilters() {
      return this.filteredRegistrations().filter(registration => registration.state === "pre_registration");
    },
    preRegistrations() {
      return this.filteredRegistrations().filter(registration => {
        const checkPreRegistrationFilter =
          this.preRegistrationFilter !== "default" && this.preRegistrationFilter !== ""
            ? registration.linked_event.type === this.preRegistrationFilter
            : true;
        return registration.state === "pre_registration" && checkPreRegistrationFilter;
      });
    },
  },
  watch: {
    selectedFilter: {
      handler(newVal, oldVal) {
        if (newVal === oldVal || this.futureViewFilter === newVal) return;
        this.setViewChanged(true);
        this.setPage(1);
        this.setFutureViewFilter(newVal);
        this.fetchRegistrations();
      },
      immediate: false,
    },
    showModal(val) {
      if (val) {
        this.$nextTick(() => {
          const modalEl = this.$el.querySelector(".dea-modal--survey-reminder");
          if (!modalEl) return;

          if (this.focusTrap === null) {
            this.focusTrap = createFocusTrap(modalEl, {
              onDeactivate: () => {
                this.showModal = false;
              },
              onPostDeactivate: () => {
                this.focusTrap = null;
              },
              escapeDeactivates: true,
              allowOutsideClick: true,
            });
            this.focusTrap.activate();
          }
        });
      } else if (this.focusTrap) {
        this.focusTrap.deactivate();
      }
    },
  },
  beforeDestroy() {
    if (this.focusTrap) this.focusTrap.deactivate();
  },
  mounted() {
    this.selectedFilter = this.futureViewFilter;
    this.selectedFromDateFilter = this.dateParams.event__date_range__start;
    this.selectedToDateFilter = this.dateParams.event__date_range__end;
  },
  methods: {
    ...mapActions(["fetchRegistration", "cancelRegistration", "fetchRegistrations"]),
    ...mapMutations([
      "setTicketFilter",
      "setRegistrations",
      "setActiveRegistrationIndex",
      "replaceEventsRegistration",
      "replaceRegistration",
      "setActiveRegistrationIndex",
      "setViewChanged",
      "setPage",
      "setFutureViewFilter",
      "setFromDateFilter",
      "setToDateFilter",
    ]),
    setPreRegistrationsFilter(event) {
      this.preRegistrationFilter = event.target.value;
    },
    focusRegistration(registration) {
      this.$router.push({ name: "registration", params: { registration: registration.id } });
    },
    editLaboratories(registration) {
      this.$router.push({ name: "laboratories", params: { registration: registration.id } });
    },
    completeSurvey(registration) {
      this.$router.push({ name: "personal-data", params: { registration: registration.id } });
    },
    downloadFiles(registration) {
      if (registration.survey_completed_date || (registration.bundle_parent && registration.is_event_attended)) {
        this.$router.push({ name: "download", params: { registration: registration.id } });
      } else {
        this.showModal = true;
      }
    },
    async runRegistrationCancel(originalRegistration) {
      const registration = await this.cancelRegistration(originalRegistration.id);
      if (registration) {
        this.replaceRegistration(registration);
        this.replaceEventsRegistration(registration);
      }
      this.modal.hide();
      this.versionIndex += 1;
    },
    triggerRegistrationCancel(registration) {
      this.modal = ModalAlert.methods.handleException(RegistrationCancellationModal, this.$root.config);
      this.modal.$on("runRegistrationCancel", () => {
        this.runRegistrationCancel(registration);
      });
    },
    getTicketWrapperComponent(registration) {
      if (registration.to_be_completed) {
        return "TicketToPayWrapper";
      }
      return "PlaceholderComponent";
    },
    changeView(event) {
      this.setTicketFilter(event);
    },
    findPackageChildren(registrationId) {
      return Object.values(this.myHomeRegistrations).filter(el => {
        return el.bundle_parent === registrationId;
      });
    },
    async goToNotAttendedEvents() {
      this.setTicketFilter("notAttended");
      this.setViewChanged(true);
      this.setPage(1);
      await this.fetchRegistrations();
    },
    async changePage(page) {
      let newPage = page;
      if (page === "prev" && this.myHomePagination.has_previous) {
        newPage = this.myHomePagination.current - 1;
      } else if (page === "next" && this.myHomePagination.has_next) {
        newPage = this.myHomePagination.current + 1;
      } else if (page === "first" && this.myHomePagination.has_previous) {
        newPage = 1;
      } else if (page === "last" && this.myHomePagination.has_next) {
        newPage = this.myHomePagination.last;
      }

      if (newPage === this.myHomePagination.current) return;

      this.setViewChanged(true);
      this.setPage(newPage);
      await this.fetchRegistrations();
    },

    async handleSelectedFromDateFilter(event) {
      const {
        target: { value },
      } = event;
      this.setViewChanged(true);
      this.setPage(1);
      this.setFromDateFilter(value);
      await this.fetchRegistrations();
    },

    async handleSelectedToDateFilter(event) {
      const {
        target: { value },
      } = event;
      this.setViewChanged(true);
      this.setPage(1);
      this.setToDateFilter(value);
      await this.fetchRegistrations();
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.subscription-container {
  &__paragraph {
    margin-bottom: $space-base;
    margin-top: $space-x-large;
  }
}

.main-tab {
  &__not-attended-events-link {
    margin-top: $space-base;
  }
}

.order-confirmation-payment {
  background-color: $dea-color-white;
  border: $border-light;
  border-radius: $border-radius-large;
  margin: $space-small $space-large;
  padding: $space-small;
}

.dea-modal--action__error-icon {
  align-items: center;
  background: $dea-color-feedback-red-negative;
  border-radius: $border-radius-circle;
  display: flex;
  height: $dea-size-large;
  justify-content: center;
  margin-bottom: $space-small;
  padding: 0;
  width: $dea-size-large;

  &:before {
    color: $dea-color-white;
    font-size: $dea-size-medium;
  }

  @include bp-large-max {
    height: $dea-size-intermediate;
    min-width: $dea-size-intermediate;
    width: $dea-size-intermediate;
  }
}

.dea-modal-overlay {
  top: 0 !important; // sass-lint:disable-line no-important

  .dea-modal {
    &__footer {
      justify-content: space-between;
    }
  }
}

.generic-container--warning {
  margin: $space-base 0 !important; // sass-lint:disable-line no-important
}

.main-tab__filters--events {
  column-gap: $space-small;
  display: flex;
  margin-top: $space-base;

  .dea-input--input-select {
    .dea-input__label-wrapper {
      @include h-font-size-medium;

      font-family: $font-primary;
      line-height: 1.25;
      margin-top: $space-x-small;
    }
  }
}

.dea-input-container--events {
  .dea-input-container__label {
    @include h-font-size-medium;

    align-items: flex-end;
    display: flex;
    font-family: $font-primary;
    justify-content: space-between;
    margin-bottom: $space-small;
    text-transform: none;
  }

  .dea-input-container__inputs {
    column-gap: $space-small;
    display: flex;
  }
}

.dea-input-container--date {
  margin-left: $space-small;
}

.dea-input-container__label--date {
  display: block;
  font-family: $font-primary-medium;
  font-size: $h-font-size-xx-small;
  margin: $space-x-small 0 $space-xx-small;
  text-transform: uppercase;
}

.dea-input--date {
  background-color: $dea-color-grey-light;
  border: 0;
  max-width: 100%;
  outline: none;
  padding: $space-small;
  width: 100%;

  &::placeholder {
    @include p_font-size-small; //sass-lint:disable-line mixin-name-format
    color: $dea-color-black;
    font-family: $font-primary-medium;
    font-weight: $font-weight-light;
    text-transform: capitalize;
  }

  &.dea-input:last-child {
    margin-block-end: $space-small;
  }
}

[package-children] {
  list-style: none;
}
</style>
